import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';
import { SimilarProductsRecoSlider } from '@packages/recommendations';
import { Typography } from '@packages/shared';
import { FormattedMessage, useIntl } from 'react-intl';
import { SlotBox } from '../SlotBox';

export const SimilarRecoFragment = graphql(/* GraphQL */ `
  fragment SimilarRecoFragment on Product {
    hasSeries
    promotion
    orderNumber
  }
`);

export type SimilarProductsProps = {
  recoData: FragmentType<typeof SimilarRecoFragment>;
};

export const SimilarProducts = ({ recoData }: SimilarProductsProps) => {
  const { hasSeries, orderNumber, promotion } = getFragmentData(SimilarRecoFragment, recoData);
  const { formatMessage } = useIntl();

  return (
    <>
      <Typography variant="h2" component="header" sx={{ m: 2 }}>
        <FormattedMessage
          defaultMessage="Empfehlungen für dich"
          id="detailview.grid.headline.recommendation"
        />
      </Typography>
      <SlotBox>
        <SimilarProductsRecoSlider
          productId={`${orderNumber}${promotion}`}
          elementIndex={hasSeries ? 3 : 2}
          fetchOnThreshold
          pageTemplate="detailview"
          title={formatMessage({
            defaultMessage: 'Ähnliche Artikel',
            id: 'rde.alternative-products.headline-fallback',
          })}
          key={`${orderNumber}${3}`}
        />
      </SlotBox>
    </>
  );
};
